/** =========================================================
 * Users controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-users')
    .controller('UsersController', UsersController);

  UsersController.$inject = ['$rootScope', '$scope', '$api', '$state', '$stateParams', '$translate', 'ngDialog'];

  function UsersController($rootScope, $scope, $api, $state, $stateParams, $translate, ngDialog) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page users',
        data: {
          filters: $stateParams.filters
        }
      });

      var addCertificate = function (item) {
        try {
          item.user_certificates.push({
            uid: null,
            issue_date: null,
            name: null
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var removeItem = function (stack, index) {
        try {
          var dialogScope = $scope.$new(true);

          dialogScope.message = 'Do you really want to delete?';

          ngDialog.openConfirm({
            template: 'app/views/dialogs/confirm.html',
            scope: dialogScope
          }).then(function () {
            var item = stack[index];
            if (item.id) {
              item.deleted_at = moment();
            } else {
              stack.splice(index, 1);
            }
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      vm.tableConfig = {
        model: 'user',
        getDataParams: {
          order: {
            id: 'desc'
          },
          with: [
            'roles',
            'permissions',
            'user_certificates'
          ],
          getAttrs: ['quantities']
        },
        filters: angular.copy($stateParams.filters),
        helpers: {
          addCertificate: addCertificate,
          removeItem: removeItem
        },
        fields: [{
          title: 'Active',
          key: 'active',
          customType: 'boolean',
          center: true,
          order: true
        }, {
          title: 'Certificates',
          key: null,
          value: function (item) {
            return item.user_certificates.map(function (cert) { return cert.uid; }).join(', ');
          }
        }, {
          title: 'Position',
          key: 'position',
          order: true
        }, {
          title: 'Name',
          key: 'name',
          order: true
        }, {
          title: 'Email',
          key: 'email',
          order: true
        }, {
          title: 'Phone',
          key: 'phone',
          order: true
        }, {
          title: 'Role',
          translate: true,
          value: function (item) {
            if (item.roles.length !== 0) {
              return item.roles[0].name.capitalize();
            }

            return '';
          }
        }, {
          title: 'Busyness',
          customType: 'html',
          value: function (item) {
            if (item.quantities) {
              return '<table><tr><td><i class="icon-folder-alt"></i>&nbsp;&nbsp;</td><td><span title="' + $translate.instant('Projects without initial act') + '">' + item.quantities.activeProjectsWithoutInitialAct + '</span>&nbsp;|&nbsp;<span title="' + $translate.instant('Projects with initial act') + '">' + item.quantities.activeProjectsWithInitialAct + '</span>&nbsp;|&nbsp;<span title="' + $translate.instant('Active projects') + '">' + item.quantities.activeProjects + '</span>&nbsp;|&nbsp;<span title="' + $translate.instant('Projects') + '">' + item.quantities.projects + '</span></td></tr><tr><td><i class="icon-layers"></i>&nbsp;&nbsp;</td><td><span title="' + $translate.instant('Project parts without initial act') + '">' + item.quantities.activeProjectPartsWithoutInitialAct + '</span>&nbsp;|&nbsp;<span title="' + $translate.instant('Project parts with initial act') + '">' + item.quantities.activeProjectPartsWithInitialAct + '</span>&nbsp;|&nbsp;<span title="' + $translate.instant('Active project parts') + '">' + item.quantities.activeProjectParts + '</span>&nbsp;|&nbsp;<span title="' + $translate.instant('Project parts') + '">' + item.quantities.projectParts + '</span></td></tr></table>';
            }

            return '';
          }
        }],
        add: {
          template: 'app/views/dialogs/item-user.html',
          wide: true,
          item: {
            user_certificates: []
          }
        },
        edit: {
          template: 'app/views/dialogs/item-user.html',
          wide: true,
          except: ['permissions', 'roles', 'quantities']
        },
        delete: {},
        linkButtons: [{
          title: 'Projects',
          icon: 'icon-folder-alt',
          class: 'btn-info mr-1',
          permission: $rootScope.helpers.hasPermissionTo('project view'),
          action: function (item) {
            try {
              $state.go('app.page-projects', {
                filters: [{
                  name: $translate.instant('User') + ': ' + item.name,
                  attr: 'where',
                  value: [
                    ['user_id', '=', item.id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          }
        }, {
          title: 'Project parts',
          icon: 'icon-layers',
          class: 'btn-info mr-1',
          permission: $rootScope.helpers.hasPermissionTo('project_part view'),
          action: function (item) {
            try {
              $state.go('app.page-project-parts', {
                filters: [{
                  name: $translate.instant('User') + ': ' + item.name,
                  attr: 'where',
                  value: [
                    ['user_id', '=', item.id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          }
        }],
        customButtons: [{
          icon: 'icon-lock',
          class: 'btn-default',
          title: 'Permissions',
          permission: $rootScope.helpers.hasPermissionTo('user edit_permissions') && $rootScope.helpers.hasPermissionTo('role view'),
          action: function (item) {
            try {
              var dialogScope = $scope.$new(true);

              dialogScope.getPermissionNamePart = function (name, index) {
                if (name) {
                  return name.split(' ')[index];
                }

                return null;
              };

              dialogScope.hasPermissionTo = function (stack, permission) {
                return stack.filter(function (stackItem) {
                  return stackItem.id === permission.id;
                }).length !== 0;
              };

              dialogScope.getRolePermissions = function (role) {
                return new Promise(function (resolve, reject) {
                  $api.getAll({
                    model: 'role',
                    data: {
                      with: ['permissions'],
                      where: [
                        ['id', '=', role.id]
                      ]
                    }
                  }).then(function (response) {
                    dialogScope.rolePermissions = response.data.items[0].permissions;

                    resolve();
                  }, reject);
                });
              };

              dialogScope.togglePermission = function (permission, value) {
                permission.value = value;
              };

              dialogScope.item = angular.copy(item);

              dialogScope.availableRoles = $rootScope.appConfig.roles;

              dialogScope.formattedPermissions = {};

              dialogScope.rolePermissions = [];

              var appPermissions = angular.copy($rootScope.appConfig.permissions);

              appPermissions.forEach(function (permission) {
                var value = dialogScope.hasPermissionTo(dialogScope.item.permissions, permission)
                  || dialogScope.hasPermissionTo(dialogScope.rolePermissions, permission);

                permission.value = value;

                var permissionModel = dialogScope.getPermissionNamePart(permission.name, 0);

                if (typeof dialogScope.formattedPermissions[permissionModel] === 'undefined') {
                  dialogScope.formattedPermissions[permissionModel] = [];
                }

                dialogScope.formattedPermissions[permissionModel].push(permission);
              });

              var before = new Promise(function (resolve) {
                dialogScope.rolePermissions = [];

                resolve(true);
              });

              if (dialogScope.item.roles.length !== 0) {
                before = dialogScope.getRolePermissions(dialogScope.item.roles[0]);
              }

              before.then(function () {
                ngDialog.openConfirm({
                  template: 'app/views/dialogs/user-permissions.html',
                  className: 'ngdialog-theme-default ngdialog-wide',
                  scope: dialogScope
                }).then(function () {
                  $api.update({
                    model: 'user_permissions',
                    data: {
                      user_id: dialogScope.item.id,
                      user_role: dialogScope.item.roles[0].name,
                      permissions: appPermissions.filter(function (permission) {
                        return typeof permission.value !== 'undefined';
                      }).map(function (permission) {
                        return {
                          name: permission.name,
                          action: (permission.value ? 'given' : 'revoked')
                        };
                      })
                    }
                  }).then(function (response) {
                    item.roles = dialogScope.item.roles;
                    item.permissions = response.data;
                  });
                });
              });
            } catch (error) {
              Raven.captureException(error);
            }
          }
        }]
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
